import { render } from "./WPPost.vue?vue&type=template&id=ea06beea&scoped=true"
import script from "./WPPost.vue?vue&type=script&lang=js"
export * from "./WPPost.vue?vue&type=script&lang=js"

import "./WPPost.vue?vue&type=style&index=0&id=ea06beea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea06beea"]])

export default __exports__